var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { icons, typeAlert, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { ReportView } from "./view";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getCatalogStatusQuote, getCatalogStatusQuoteClearData, } from "../../store/catalog/actions";
import { showErrorToast } from "../../fnx/showError";
import showToast from "../../services/toast";
import { useTranslation } from "react-i18next";
import { quoteAll } from "../../store/generateQuote/actions";
import { getCurrentMonth, getCurrentSemester, getPreviousMonth, getQuarterDates, } from "../../services/getDates";
import { categories, downData, seriesFn } from "./reportPageDTO";
import { formattedDateWithTime } from "../../utils/date";
import { downloadReports } from "../../fnx/reportsDowload";
import LocalStorageService from "../../services/localStorage";
import { GetAllPerson } from "../../fnx/person/getAllPerson";
import { AlertLoadingHeader } from "../../components/alertLoadingComponent/alertLoading";
import { getQuoteList } from "../../utils/normalizeQuoteResponse";
var storageKey2 = "assurehub";
var lsLogin = new LocalStorageService(storageKey2);
export var ReportPage = function () {
    var t = useTranslation().t;
    var dispatch = useDispatch();
    var navigate = useNavigate();
    var _a = React.useState(true), enable = _a[0], setEnable = _a[1];
    var _b = React.useState(1), page = _b[0], setPage = _b[1];
    var _c = React.useState(5000), limit = _c[0], setLimit = _c[1];
    var _d = React.useState(false), trigger = _d[0], setTrigger = _d[1];
    var _e = useState({}), idStatus = _e[0], setIdStatus = _e[1];
    var _f = useState(downData), newDownData = _f[0], setNewDownData = _f[1];
    var _g = useState(seriesFn(t)), dataSeries = _g[0], setDataSeries = _g[1];
    var _h = useState(categories), dataCategories = _h[0], setDataCategories = _h[1];
    var _j = React.useState(false), isLoadin = _j[0], setIsLoading = _j[1];
    var _k = React.useState(""), startDate = _k[0], setStartDate = _k[1];
    var _l = React.useState(""), endDate = _l[0], setEndDate = _l[1];
    var clientId = React.useState(lsLogin.getUserLoginStored().clientId)[0];
    var fields = "policyId.code,code,productId.description,policyId.effectiveFrom,creationDate,firstNameA,firstNameB,lastNameA,lastNameB,numberId,customerAccount.accountType.description,customerAccount.accountNumber,customerAccount.amount,catalogStatusQuote.description,user.fullName,user.email,clientId.description,catalogCancellation.createdAt,catalogCancellation.description";
    var labelFields = "Póliza,Cotización,Producto,Fecha efectiva,Póliza creada el,Primer nombre,Segundo nombre,Primer apellido,Segundo apellido,No. Documento,Tipo de cuenta,No. de cuenta,Prima,Estado,Nombre del empleado,Usuario,Aseguradora,Fecha de cancelación,Motivo de cancelación";
    var _m = React.useState({
        show: false,
        message: "",
        type: typeAlert.success,
    }), seeToast = _m[0], setSeeToast = _m[1];
    var _o = useSelector(function (state) {
        var _a;
        return ({
            responseGetCatalogStatusQuote: (_a = state.Catalog.responseGetCatalogStatusQuote) === null || _a === void 0 ? void 0 : _a.data,
            errorGetCatalogStatusQuote: state.Catalog.errorGetCatalogStatusQuote,
            loadingGetCatalogStatusQuote: state.Catalog.loadingGetCatalogStatusQuote,
        });
    }), responseGetCatalogStatusQuote = _o.responseGetCatalogStatusQuote, errorGetCatalogStatusQuote = _o.errorGetCatalogStatusQuote, loadingGetCatalogStatusQuote = _o.loadingGetCatalogStatusQuote;
    var _p = useSelector(function (state) { return ({
        responseAllQuote: state.Quote.responseAllQuote,
        errorAllQuote: state.Quote.errorAllQuote,
        loadingAllQuote: state.Quote.loadingAllQuote,
    }); }), responseAllQuote = _p.responseAllQuote, errorAllQuote = _p.errorAllQuote, loadingAllQuote = _p.loadingAllQuote;
    var _q = GetAllPerson(trigger), responsePerson = _q.responsePerson, errorPerson = _q.errorPerson, loadingPerson = _q.loadingPerson;
    useEffect(function () {
        if (!responseGetCatalogStatusQuote) {
            dispatch(getCatalogStatusQuote({ enable: enable, page: page, limit: limit }));
        }
        var _a = getCurrentMonth(), startDate = _a.startDate, endDate = _a.endDate;
        setDate(startDate, endDate);
        setStartDate(startDate);
        setEndDate(endDate);
        setTrigger(true);
    }, []);
    useEffect(function () {
        if (errorGetCatalogStatusQuote) {
            showErrorToast(errorGetCatalogStatusQuote, setSeeToast, t);
        }
    }, [errorGetCatalogStatusQuote]);
    useEffect(function () {
        if (errorPerson) {
            showErrorToast(errorPerson, setSeeToast, t);
        }
    }, [errorPerson]);
    useEffect(function () {
        if (errorAllQuote) {
            showErrorToast(errorAllQuote, setSeeToast, t);
        }
    }, [errorAllQuote]);
    useEffect(function () {
        if (Array.isArray(responseGetCatalogStatusQuote)) {
            setStatusOptionsSto(responseGetCatalogStatusQuote);
        }
    }, [responseGetCatalogStatusQuote]);
    useEffect(function () {
        var quoteList = getQuoteList(responseAllQuote);
        if (quoteList.length > 0) {
            // LLENA DATA DE LOS DOWNCARD
            var filteredPolicy = quoteList.filter(function (item) { var _a; return ((_a = item.catalogStatusQuote) === null || _a === void 0 ? void 0 : _a.description) === "Emitida"; });
            var canceledPolicy = quoteList.filter(function (item) { var _a; return ((_a = item.catalogPolicyStatus) === null || _a === void 0 ? void 0 : _a.description) === "Cancelada"; });
            var quotedPolicy = quoteList.filter(function (item) { var _a; return ((_a = item.catalogStatusQuote) === null || _a === void 0 ? void 0 : _a.description) === "Cotizada"; });
            var salesCount_1 = filteredPolicy.length;
            var canceledPolicyCount_1 = canceledPolicy.length;
            var quotedPolicyCount_1 = quotedPolicy.length;
            setNewDownData(function (prevData) {
                return prevData.map(function (card) {
                    switch (card.id) {
                        case "1":
                            return __assign(__assign({}, card), { numericalTitle: salesCount_1.toString() });
                        case "2":
                            return __assign(__assign({}, card), { numericalTitle: quotedPolicyCount_1.toString() });
                        case "3":
                            return __assign(__assign({}, card), { numericalTitle: canceledPolicyCount_1.toString() });
                        default:
                            return card;
                    }
                });
            });
            //LLENA LA DATA DEL CHART
            var productCount_1 = {};
            quoteList.forEach(function (item) {
                var _a, _b, _c;
                var productId = (_a = item === null || item === void 0 ? void 0 : item.productId) === null || _a === void 0 ? void 0 : _a.id;
                var description = (_b = item === null || item === void 0 ? void 0 : item.productId) === null || _b === void 0 ? void 0 : _b.description;
                var status = (_c = item === null || item === void 0 ? void 0 : item.catalogStatusQuote) === null || _c === void 0 ? void 0 : _c.description;
                if (!productCount_1[productId]) {
                    productCount_1[productId] = {
                        description: description,
                        countsByStatus: {},
                    };
                }
                if (productCount_1[productId].countsByStatus[status]) {
                    productCount_1[productId].countsByStatus[status] += 1;
                }
                else {
                    productCount_1[productId].countsByStatus[status] = 1;
                }
            });
            var sortedProducts = Object.keys(productCount_1)
                .map(function (key) {
                var product = productCount_1[key];
                var totalCount = Object.values(product.countsByStatus).reduce(function (sum, count) { return sum + count; }, 0);
                return __assign(__assign({}, product), { id: key, totalCount: totalCount });
            })
                .sort(function (a, b) { return b.totalCount - a.totalCount; });
            var top5Products = sortedProducts.slice(0, 5);
            var issuedData_1 = top5Products.map(function (product) { return product.countsByStatus["Emitida"] || 0; });
            var listedData_1 = top5Products.map(function (product) { return product.countsByStatus["Cotizada"] || 0; });
            var categoriesData = top5Products.map(function (product) { return product.description; });
            setDataSeries(function (prevSeries) {
                return [
                    __assign(__assign({}, prevSeries[0]), { data: issuedData_1 }),
                    __assign(__assign({}, prevSeries[1]), { data: listedData_1 }),
                ];
            });
            setDataCategories(categoriesData);
        }
    }, [responseAllQuote]);
    useEffect(function () {
        if (responsePerson) {
            var clientsCount_1 = responsePerson.length;
            setNewDownData(function (prevData) {
                return prevData.map(function (card) {
                    switch (card.id) {
                        case "4":
                            return __assign(__assign({}, card), { numericalTitle: clientsCount_1.toString() });
                        default:
                            return card;
                    }
                });
            });
        }
    }, [responsePerson]);
    var setStatusOptionsSto = function (responseGetCatalogStatusQuote) {
        var status = {};
        responseGetCatalogStatusQuote.forEach(function (item) {
            if (item.id && item.description) {
                if (item.description === "Emitida") {
                    status.emitida = item.id;
                }
                else if (item.description === "Cancelada") {
                    status.cancelada = item.id;
                }
            }
        });
        setIdStatus(status);
        dispatch(getCatalogStatusQuoteClearData());
    };
    var openReport = function (action, item) {
        if (action.name === "Previsualizar") {
            switch (item.code) {
                case "vents":
                    navigate("/report/sales/".concat(idStatus.emitida));
                    break;
                case "polCancel":
                    navigate("/report/sales/".concat(idStatus.cancelada));
                    break;
                case "vents&cancel":
                    navigate("/report/sales/");
                    break;
                case "firstFee":
                    navigate("/report/first-fee/");
                    break;
                case "travelAssistance":
                    navigate("/report/travel-assistance/");
                    break;
                case "healthPreferential":
                    navigate("/report/health-preferential/");
                    break;
                case "upcomingCancellations":
                    navigate("/report/upcoming-cancellations/");
                    break;
                case "balanceAging":
                    navigate("/report/balance-aging/");
                    break;
            }
        }
        if (action.name === "Descargar") {
            var newItem = {
                id: "1",
                icons: icons.DownloadForOffline,
                name: "Descargar Excel",
            };
            switch (item.code) {
                case "vents":
                    onClickDownload(newItem, idStatus.emitida || "");
                    break;
                case "polCancel":
                    onClickDownload(newItem, idStatus.cancelada || "");
                    break;
                case "vents&cancel":
                    navigate("/report/sales/");
                    break;
                case "firstFee":
                    navigate("/report/first-fee/");
                    break;
                case "travelAssistance":
                    navigate("/report/travel-assistance/");
                    break;
                case "healthPreferential":
                    navigate("/report/health-preferential/");
                    break;
                case "upcomingCancellations":
                    navigate("/report/upcoming-cancellations/");
                    break;
                case "balanceAging":
                    navigate("/report/balance-aging/");
                    break;
            }
        }
    };
    var onClickChip = function (item) {
        var _a, _b, _c, _d, _e;
        var startDate, endDate;
        switch (item.code) {
            case "currentMonth":
                (_a = getCurrentMonth(), startDate = _a.startDate, endDate = _a.endDate);
                setDate(startDate, endDate);
                setStartDate(startDate);
                setEndDate(endDate);
                break;
            case "prevMonth":
                (_b = getPreviousMonth(), startDate = _b.startDate, endDate = _b.endDate);
                setDate(startDate, endDate);
                setStartDate(startDate);
                setEndDate(endDate);
                break;
            case "currentQuarter":
                (_c = getQuarterDates("current"), startDate = _c.startDate, endDate = _c.endDate);
                setDate(startDate, endDate);
                setStartDate(startDate);
                setEndDate(endDate);
                break;
            case "prevQuarter":
                (_d = getQuarterDates("previous"), startDate = _d.startDate, endDate = _d.endDate);
                setDate(startDate, endDate);
                setStartDate(startDate);
                setEndDate(endDate);
                break;
            case "currentSemester":
                (_e = getCurrentSemester(), startDate = _e.startDate, endDate = _e.endDate);
                setDate(startDate, endDate);
                setStartDate(startDate);
                setEndDate(endDate);
                break;
        }
    };
    var setDate = function (date1, date2) {
        dispatch(quoteAll({
            enable: enable,
            creationDateStart: date1,
            creationDateEnd: date2,
            page: page,
            limit: limit,
        }));
    };
    var filterCalendar = function (dates) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        var startDate = formattedDateWithTime((_a = dates === null || dates === void 0 ? void 0 : dates.dateRange) === null || _a === void 0 ? void 0 : _a.startDate) === "undefined" ||
            formattedDateWithTime((_b = dates === null || dates === void 0 ? void 0 : dates.dateRange) === null || _b === void 0 ? void 0 : _b.startDate) === "null" ||
            formattedDateWithTime((_c = dates === null || dates === void 0 ? void 0 : dates.dateRange) === null || _c === void 0 ? void 0 : _c.startDate) === "NA"
            ? ""
            : formattedDateWithTime((_d = dates === null || dates === void 0 ? void 0 : dates.dateRange) === null || _d === void 0 ? void 0 : _d.startDate);
        var endDate = formattedDateWithTime((_e = dates === null || dates === void 0 ? void 0 : dates.dateRange) === null || _e === void 0 ? void 0 : _e.endDate) === "undefined" ||
            formattedDateWithTime((_f = dates === null || dates === void 0 ? void 0 : dates.dateRange) === null || _f === void 0 ? void 0 : _f.endDate) === "null" ||
            formattedDateWithTime((_g = dates === null || dates === void 0 ? void 0 : dates.dateRange) === null || _g === void 0 ? void 0 : _g.endDate) === "NA"
            ? ""
            : formattedDateWithTime((_h = dates === null || dates === void 0 ? void 0 : dates.dateRange) === null || _h === void 0 ? void 0 : _h.endDate);
        setDate(startDate, endDate);
        setStartDate(startDate);
        setEndDate(endDate);
    };
    var closeCalendar = function () {
        var _a = getCurrentMonth(), startDate = _a.startDate, endDate = _a.endDate;
        setDate(startDate, endDate);
        setStartDate(startDate);
        setEndDate(endDate);
    };
    var onClickDownload = function (item, id) {
        setIsLoading(true);
        downloadReports(item, clientId, enable, page, limit, id ? id : "", startDate, endDate, fields, labelFields)
            .then(function () {
            setSeeToast({
                show: true,
                message: "Archivo descargado con éxito",
                type: typeAlert.success,
            });
        })
            .catch(function (error) {
            console.error("Error al descargar el archivo:", error);
        })
            .finally(function () {
            setIsLoading(false);
        });
    };
    return (_jsxs(React.Fragment, { children: [_jsx(AlertLoadingHeader, { loading: loadingGetCatalogStatusQuote || loadingAllQuote || loadingPerson, seeToast: seeToast, showToast: showToast, setSeeToast: setSeeToast, titleLoading: "Cargando datos." }), _jsx(ReportView, { onClickOptionChips: onClickChip, openReport: openReport, newDownData: newDownData, dataSeries: dataSeries, dataCategories: dataCategories, closeCalendar: closeCalendar, filterCalendar: filterCalendar, t: t })] }));
};
